/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

import { QuickSearchGeometryResponseDto } from '../../models/quick-search-geometry-response-dto';

export interface GetQuickSearchGeometry$Params {
  searchFor: string;
  searchType: string;
}

export function getQuickSearchGeometry(
  http: HttpClient,
  rootUrl: string,
  params: GetQuickSearchGeometry$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<QuickSearchGeometryResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getQuickSearchGeometry.PATH, 'get');
  if (params) {
    rb.query('searchFor', params.searchFor, {});
    rb.query('searchType', params.searchType, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<QuickSearchGeometryResponseDto>;
      }),
    );
}

getQuickSearchGeometry.PATH = '/quick-search/geometry';
